(()=> {
  const initTabs=(scope=document)=>{
    scope.querySelectorAll('[data-nw-tabs]').forEach(root=>{
      if(root.dataset.nwReady)return; root.dataset.nwReady='1';
      root.addEventListener('click',e=>{
        const b=e.target.closest('[data-nw-tab]'); if(!b)return;
        const key=b.dataset.nwTab;
        root.querySelectorAll('[data-nw-tab]').forEach(x=>{const on=x===b;x.classList.toggle('is-active',on);x.setAttribute('aria-selected',on?'true':'false')});
        root.querySelectorAll('[data-nw-panel]').forEach(p=>{const on=p.dataset.nwPanel===key;p.classList.toggle('is-active',on);p.hidden=!on});
      });
    });
    scope.querySelectorAll('[data-nw-collection-tabs]').forEach(root=>{
      if(root.dataset.nwReady)return; root.dataset.nwReady='1';
      root.addEventListener('click',e=>{
        const b=e.target.closest('[data-nw-ctab]'); if(!b)return;
        const key=b.dataset.nwCtab;
        root.querySelectorAll('[data-nw-ctab]').forEach(x=>{const on=x===b;x.classList.toggle('is-active',on);x.setAttribute('aria-selected',on?'true':'false')});
        root.querySelectorAll('[data-nw-cpanel]').forEach(p=>{const on=p.dataset.nwCpanel===key;p.classList.toggle('is-active',on);p.hidden=!on});
      });
    });
  };

  const focusSearch=()=>{
    const searchModal=document.querySelector('#search-modal');
    if(!searchModal)return;
    if(typeof searchModal.showDialog==='function')searchModal.showDialog();
    else document.querySelector('[on\:click="#search-modal/showDialog"]')?.click();
    const focusInput=()=>{
      const input=searchModal.querySelector('input[type="search"]');
      if(!input)return;
      try{input.focus({preventScroll:true});}catch(_){input.focus();}
    };
    requestAnimationFrame(()=>setTimeout(focusInput,80));
  };

  const openMenu=()=>{
    const summary=document.querySelector('#Details-menu-drawer-container > summary');
    if(summary instanceof HTMLElement)summary.click();
  };

  const openCart=()=>{
    const drawer=document.querySelector('#cart-drawer');
    if(drawer && typeof drawer.open==='function')drawer.open();
    else window.location.assign('/cart');
  };

  const initMobileUX=()=>{
    const toolbar=document.querySelector('[data-nw-mobile-toolbar]');
    if(!toolbar || toolbar.dataset.nwMobileReady)return;
    toolbar.dataset.nwMobileReady='1';

    toolbar.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-nw-mobile-action]');
      if(!trigger)return;
      const action=trigger.dataset.nwMobileAction;
      if(action==='menu')openMenu();
      if(action==='search')focusSearch();
      if(action==='cart')openCart();
    });

    let lastY=Math.max(0,window.scrollY || document.documentElement.scrollTop || 0);
    let ticking=false;
    const updateToolbar=()=>{
      const y=Math.max(0,window.scrollY || document.documentElement.scrollTop || 0);
      const delta=y-lastY;
      if(y<44)toolbar.classList.remove('is-condensed');
      else if(delta>5)toolbar.classList.add('is-condensed');
      else if(delta<-5)toolbar.classList.remove('is-condensed');
      lastY=y;
      ticking=false;
    };
    window.addEventListener('scroll',()=>{
      if(ticking)return;
      ticking=true;
      requestAnimationFrame(updateToolbar);
    },{passive:true});

    document.addEventListener('shopify:cart:lines-update',event=>{
      event.promise?.then(({cart,detail})=>{
        const count=cart?.totalQuantity ?? detail?.itemCount ?? 0;
        document.querySelectorAll('[data-nw-cart-count]').forEach(badge=>{
          badge.textContent=String(count);
          badge.classList.toggle('is-empty',count===0);
        });
      }).catch(()=>{});
    });

    // Keep the toolbar from covering footer links and browser-keyboard interactions.
    const footer=document.querySelector('#footer-group');
    if(footer && 'IntersectionObserver' in window){
      const footerObserver=new IntersectionObserver(entries=>{
        toolbar.classList.toggle('is-footer-near',entries.some(entry=>entry.isIntersecting));
      },{root:null,rootMargin:'0px 0px 84px 0px',threshold:.01});
      footerObserver.observe(footer);
    }

    const viewport=window.visualViewport;
    if(viewport){
      const updateKeyboardState=()=>{
        const keyboardLikelyOpen=viewport.height < window.innerHeight * .72;
        toolbar.classList.toggle('is-keyboard-open',keyboardLikelyOpen);
      };
      viewport.addEventListener('resize',updateKeyboardState,{passive:true});
      viewport.addEventListener('scroll',updateKeyboardState,{passive:true});
      updateKeyboardState();
    }
  };

  const init=()=>{
    initTabs();
    initMobileUX();
  };

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
  document.addEventListener('shopify:section:load',e=>{initTabs(e.target);});

  // Theme editor: selecting a block must reveal the UI that owns it.
  document.addEventListener('shopify:block:select',e=>{
    const target=e.target instanceof Element ? e.target : null;
    if(!target)return;

    const collectionTabs=target.closest('[data-nw-collection-tabs]');
    if(collectionTabs){
      const blockId=e.detail?.blockId || target.getAttribute('data-block-id');
      const button=blockId ? collectionTabs.querySelector(`[data-nw-ctab=\"${CSS.escape(blockId)}\"]`) : null;
      if(button instanceof HTMLElement)button.click();
    }

    requestAnimationFrame(()=>{
      try{target.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}catch(_){target.scrollIntoView();}
    });
  });
})();
